module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_agder_neg.a8974815.png";